import type { TStoreName } from "../types/store";
import { buildDocument } from "./build-document";
import { APP_NAME, STORE_SUFFIX } from "./store";

/** 스토어별로 다른 쿼리만 키로 두고, 나머지는 default 에 `${S}` 보간으로 한 벌만 유지한다. */
const withFragments = (operations: Partial<Record<TStoreName, string>> & { default: string }) =>
  buildDocument(operations[APP_NAME] ?? operations.default);

const S = STORE_SUFFIX;

export const cartQuery = withFragments({
  default: `#graphql
    query Cart${S}($id: ID!) { cart(id: $id) { ...CartFields${S} } }
  `,
});

export const cartAttributesUpdateMutation = withFragments({
  default: `#graphql
    mutation CartAttributesUpdate${S}($cartId: ID!, $attributes: [AttributeInput!]!) {
      cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
        cart { ...CartFields${S} }
        userErrors { ...CartUserErrorFields }
      }
    }
  `,
});

export const cartBuyerIdentityUpdateMutation = withFragments({
  default: `#graphql
    mutation CartBuyerIdentityUpdate${S}($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
      cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
        cart { ...CartFields${S} }
        userErrors { ...CartUserErrorFields }
      }
    }
  `,
});

export const cartCreateMutation = withFragments({
  default: `#graphql
    mutation CartCreate${S} {
      cartCreate { 
        cart { ...CartFields${S} } 
        userErrors { ...CartUserErrorFields }
      }
    }
  `,
  tune: `#graphql
    mutation CartCreateTune {
      cartCreate { cart { ...CartFieldsTune } userErrors { ...CartUserErrorFields }
      }
    }
  `,
  thisisneverthat: `#graphql
    mutation CartCreateThisisneverthat {
      cartCreate {
        cart { ...CartFieldsThisisneverthat } 
        userErrors { ...CartUserErrorFields }
      }
    }
  `,
  sunlove: `#graphql
    mutation CartCreateSunlove {
      cartCreate {
        cart { ...CartFieldsSunlove } 
        userErrors { ...CartUserErrorFields }
      }
    }
  `,
});

export const cartCreateInputMutation = withFragments({
  default: `#graphql
    mutation CartCreateInput${S}($input: CartInput!) {
      cartCreate(input: $input) { 
        cart { ...CartFields${S} } 
        userErrors { ...CartUserErrorFields }
      }
    }
  `,
  tune: `#graphql
    mutation CartCreateInputTune($input: CartInput!) {
      cartCreate(input: $input) { 
        cart { ...CartFieldsTune }
        userErrors { ...CartUserErrorFields }
      }
    }
  `,
  yeseyesee: `#graphql
    mutation CartCreateInputYeseyesee($input: CartInput!) {
      cartCreate(input: $input) {
        cart { ...CartFieldsYeseyesee } 
        userErrors { ...CartUserErrorFields }
      }
    }
  `,
});

export const cartDiscountCodesUpdateMutation = withFragments({
  default: `#graphql
    mutation CartDiscountCodesUpdate${S}($cartId: ID!, $discountCodes: [String!]!) {
      cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
        cart { ...CartFields${S} }
        userErrors { ...CartUserErrorFields }
      }
    }
  `,
});

/* ------------------------------------------------------------------ *
 * 카트 라인 추가
 * ------------------------------------------------------------------ */

export const cartLinesAddMutation = withFragments({
  default: `#graphql
    mutation CartLinesAdd${S}($cartId: ID!, $lines: [CartLineInput!]!) {
      cartLinesAdd(cartId: $cartId, lines: $lines) {
        cart { ...CartFields${S} }
        userErrors { ...CartUserErrorFields }
      }
    }
  `,
});

/* ------------------------------------------------------------------ *
 * 카트 라인 제거
 * ------------------------------------------------------------------ */

export const cartLinesRemoveMutation = withFragments({
  default: `#graphql
    mutation CartLinesRemove${S}($cartId: ID!, $lineIds: [ID!]!) {
      cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
        cart { ...CartFields${S} }
        userErrors { ...CartUserErrorFields }
      }
    }
  `,
});

/* ------------------------------------------------------------------ *
 * 카트 라인 수량 변경
 * ------------------------------------------------------------------ */

export const cartLinesUpdateMutation = withFragments({
  default: `#graphql
    mutation CartLinesUpdate${S}($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
      cartLinesUpdate(cartId: $cartId, lines: $lines) {
        cart { ...CartFields${S} }
        userErrors { ...CartUserErrorFields }
      }
    }
  `,
});
